// Invitee-side routes of the accept-invite flow (BL-1833 PR 2b). Both run
// before the invitee is a staff member of anything, so neither is bound to the
// ADR 062 gate — which would 401 them — and each declares why.
import { defineAdminRoute } from './define-admin-route';

const PRE_AUTH = {
  grant: { none: 'pre-auth — the invite token (and, for accept, the invitee\'s own session) authorizes it' },
  tenant: { from: 'none', reason: 'pre-auth — the invitee holds no staff membership yet' },
} as const;

export const invites = {
  accept: defineAdminRoute({
      path: '/api/invites/accept',
      params: {},
      methods: { POST: { ...PRE_AUTH } },
    }),
  // BUG-987: token-gated email verification for the accept-invite password path.
  verifyEmail: defineAdminRoute({
      path: '/api/invites/verify-email',
      params: {},
      methods: { POST: { ...PRE_AUTH } },
    }),
};
